import EntitytHealthDonut from './EntitySectionCard/EnitytHealthDonut';
import { SectionCard } from './EntitySectionCard/SectionCard';
import Link from './link/Link';
import LinkV2 from './link/LinkV2';
import { LinkRenderer } from './link/LinkRenderer';
import { ECPLinkRenderer } from './link/ECPLinkRenderer';
import { LI, UL } from './List';
import { SystemSelect } from './Select';
import { MultiSelect } from './MultiSelect';
import { DashifyHighcharts } from './DashifyHighcharts';
import { DataGrid, DataGridMultilineCellRenderer } from './DataGrid';
import { DataTable } from './DataTable';
import { Health } from './Health';
import {
  Button,
  Card,
  Dropdown,
  Drawer,
  FlowMap,
  Heading,
  HealthBar,
  Icon,
  Layout,
  Pill,
  Select,
  TabList,
  Tag,
  TimelineBar,
  Tooltip,
  Collapse,
  CodeSnippet,
} from '@appd/uik';
import { RGLGridLayout } from './RGLGridLayout';
import { RGLResponsiveGridLayout } from './RGLResponsiveGridLayout';
import { If, Then, Else, When, Unless, Switch, Case, Default } from 'react-if';
import { HealthIconCellRenderer } from '../health/HealthIconCellRenderer';
import { SparklineCellRenderer } from './cartesian/SparklineCellRenderer';
import { IconCellRenderer } from './icon/IconCellRenderer';
import { BgColorCellRenderer, TextColorCellRenderer, TagCellRenderer } from './thresholdCellRenderer';
import { ElementMap } from './ElementMap';
import { Demo } from './Demo';
import { Image } from './img';
import { Grid } from './Grid';
import { GridLayoutCard } from './ReactGridLayout/GridLayoutCard';
import { GridLayoutSection } from './ReactGridLayout/GridLayoutSection';
import { CodePopover } from './CodePopover';
import { Fragment } from 'react';
import { Filter } from './Filter';
import { DashifyContainer } from './DashifyContainer';
import { DashifyCard } from './DashifyCard';
import { SvgJson } from './SvgJson';
import { EditorFilterBar } from './EditorFilterBar';
import { StatedContainer } from './StatedContainer';
import { DashifySelect } from './DashifySelect';
import { ViewRenderer } from './DashboardViewer';
import { BusinessJourneyComponent } from './businessJourney';
import { DashifySearchBox } from './SearchBox/DashifySearchBox';
import { DashifyDropdown } from './DashifyDropdown';
import { DashifyHealthBar } from './DashifyHealthBar';
import { TextWithHTML } from './TextWithHTML';
import { TrafficLight } from './TrafficLight';
import { JSONEditor } from './JSONEditor';

export * from './DashboardPage';
export * from './DashboardSourceCode';
export * from './DashboardViewer';
export * from './DataTable';
export { ComponentType } from './widget/models/propertiesModels';

const { Status } = Tag;

export const ComponentRegistry = {
  'dashify:Test': (props: unknown) => <pre>{JSON.stringify(props, null, 2)} </pre>,
  'dashify:SelectDeprecated': SystemSelect,
  'dashify:Select': DashifySelect,
  'dashify:Dropdown': DashifyDropdown,
  'dashify:MultiSelect': MultiSelect,
  'dashify:UL': UL,
  'dashify:LI': LI,
  'dashify:DataGrid': DataGrid,
  'dashify:DataGridMultilineCellRenderer': DataGridMultilineCellRenderer, // todo: remove with migrtion to DataTable
  'dashify:DataTable': DataTable,
  'editable:Filter': Filter,
  'editable:FilterBar': EditorFilterBar,
  'dashify:Grid': Grid,
  'dashify:Highcharts': DashifyHighcharts,
  'dashify:Health': Health,
  'dashify:HealthIconCellRenderer': HealthIconCellRenderer,
  'dashify:TextColorCellRenderer': TextColorCellRenderer,
  'dashify:BgColorCellRenderer': BgColorCellRenderer,
  'dashify:TagCellRenderer': TagCellRenderer,
  'dashify:IconCellRenderer': IconCellRenderer,
  'dashify:Link': Link,
  'dashify:LinkV2': LinkV2,
  'dashify:LinkRenderer': LinkRenderer,
  'dashify:ECPLinkRenderer': ECPLinkRenderer,
  'dashify:SparklineCellRenderer': SparklineCellRenderer,
  'dashify:RGLResponsiveGridLayout': RGLResponsiveGridLayout,
  'dashify:RGLGridLayout': RGLGridLayout,
  'dashify:GridLayout.Section': GridLayoutSection,
  'dashify:GridLayout.Card': GridLayoutCard,
  'dashify:If': If,
  'dashify:Then': Then,
  'dashify:Else': Else,
  'dashify:When': When,
  'dashify:Unless': Unless,
  'dashify:Switch': Switch,
  'dashify:Case': Case,
  'dashify:Default:': Default,
  'dashify:CodePopover': CodePopover,
  'dashify:ElementMap': ElementMap,
  'dashify:Demo': Demo,
  'dashify:Container': DashifyContainer,
  'dashify:Card': DashifyCard,
  'dashify:Tag': Tag,
  'dashify:Status': Status,
  'dashify:SearchBox': DashifySearchBox,
  'dashify:StatedContainer': StatedContainer,
  'dashify:TrafficLight': TrafficLight,
  'dashify:HealthBar': DashifyHealthBar,
  'dashify:Drawer': Drawer,
  /** @experimental */
  'dashify:Group': ViewRenderer.halfHeartedAttemptToSupportSlots('dashify:Group', Layout.Group, ['controls']),
  /** @experimental */
  'dashify:Header': Layout.Header,
  /** @experimental */
  'dashify:Header.Button': Layout.Header.Button,
  /** @experimental */
  'dashify:Layout': Layout,
  /** @experimental */
  'dashify:Section': Layout.Section,
  /** @experimental */
  'dashify:Widget': Layout.Widget,
  'uik:Button': Button,
  'uik:Card.Container': Card.Container,
  'uik:Card': Card,
  'uik:FlowMap.Constellation': FlowMap.Constellation,
  'uik:FlowMap.Dependency': FlowMap.Dependency,
  'uik:Heading': Heading,
  'uik:HealthBar': HealthBar,
  'uik:Icon': Icon,
  /** @deprecated Use `"dashify:Layout"` instead */
  'uik:Layout': Layout,
  /** @deprecated Use `"dashify:Layout"` instead */
  'uik:Layout.Provider': Layout.Provider,
  'uik:Select': Select,
  'uik:Select.Searchable': Select.Searchable,
  'uik:Select.Option': Select.Option,
  'uik:TabList': TabList,
  'uik:TimelineBar': TimelineBar,
  'uik:Tooltip': Tooltip,
  'uik:Pill': Pill,
  'uik:Dropdown': Dropdown,
  'uik:Dropdown.Option': Dropdown.Option,
  'dashify:SvgJson': SvgJson,
  'biq:BusinessJourneyComponent': BusinessJourneyComponent,
  'dashify:TextWithHTML': TextWithHTML,
  fragment: Fragment,
  img: Image,
  'dashify:EntitySection': SectionCard,
  'dashify:EntityHealthDonut': EntitytHealthDonut,
  'dashify:JSONEditor': JSONEditor,
  'uik:Collapse': Collapse,
  'uik:Collapse.Header': Collapse.Header,
  'uik:Collapse.Panel': Collapse.Panel,
  'uik:Collapse.Group': Collapse.Group,
  'uik:CodeSnippet': CodeSnippet,
};
